import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { APP_CREDENTIALS } from "../../config/demoCredentials";
// Components
import ProjectBox from "../Elements/ProjectBox";
import FullButton from "../Buttons/FullButton";
import FilterGroup from "../Buttons/FilterGroup";
// Assets
import ProjectImg1 from "../../assets/img/projects/1.png";
import BookingAgent from "../../assets/img/agents/booking_agent.jpg";
import Chatbot from "../../assets/img/agents/chatbot.jpg";
import ATS from "../../assets/img/agents/ats.jpg";
import RequirementForge from "../../assets/img/agents/requirement_forge.jpg";
import SmartRoute from "../../assets/img/agents/smartroute.jpg";
import IRIS from "../../assets/img/agents/iris.jpg";
import QRCode from "../../assets/img/agents/qr-code.jpg";
import VideoStreamPlatform from "../../assets/img/agents/video-streaming-platform.png";
import UrbanFarming from "../../assets/img/agents/urban_farming.png";
import { useHistory } from "react-router-dom";
import ExpenseTracker from "../../assets/img/agents/expense_tracker.png";
import Quizorra from "../../assets/img/agents/quizoraa.png";
import ThreeD from "../../assets/img/agents/360-view.png";
import UlcerSight from "../../assets/img/agents/ulcer_sight.png";
import AISalesTraining from "../../assets/img/agents/ai-sales-tranning.png";
import AIMachineTraining from "../../assets/img/agents/ai-machine-tranning.png";
import PMS from "../../assets/img/agents/pms.png";
import PropertyImage from "../../assets/img/agents/property.png";

let cardData = [
  {
    id: 1,
    to: "/booking-agent",
    title: "Booking Agent",
    description:
      "Step into the future of effortless appointments. Our AI-powered Booking Agent is designed to simplify scheduling across industries—whether it’s a doctor’s visit, salon appointment, business consultation, or service request.",
    category: "Booking Agent",
    image: BookingAgent,
  },
  {
    id: 2,
    to: "/chat-bot",
    title: "Chatbot",
    description:
      "Say hello to your always-on, always-helpful virtual assistant—designed to understand, respond, and evolve with every interaction. This isn’t just another chatbot. It’s a smart, conversational powerhouse that connects with users in real time, across platforms, and in natural language.",
    category: "Personal AI Assistant",
    image: Chatbot,
  },
  {
    id: 3,
    to: "/ats-demo",
    title: "Resume ATS Score Analyzer",
    description:
      "Instantly evaluate your resume's compatibility with Applicant Tracking Systems. Our AI-powered tool analyzes your resume against job descriptions to maximize your chances of getting past automated screening systems and into the hands of recruiters.",
    category: "Resume ATS Analyzer",
    image: ATS,
  },
  {
    id: 4,
    to: "/requirement-forge-demo",
    title: "RequirementForge AI",
    description:
      "RequirementForge AI is an intelligent assistant that streamlines software development requirements gathering. It engages stakeholders in natural, intuitive conversations to collect project details, technical specifications, business objectives, and functional needs—then automatically generates detailed and structured documentation to kickstart development.",
    category: "Sales Support",
    image: RequirementForge,
  },
  {
    id: 5,
    to: "/google-map-route-demo",
    title: "Google SmartRoute Planner",
    description:
      "Google SmartRoute Planner is an advanced navigation and route optimization tool designed to transform your travel and delivery planning experience.",
    category: "Smart Planner",
    image: SmartRoute,
  },
  {
    id: 6,
    to: "/resume-analyse-chat-bot",
    title: "IRIS (Intelligent Resume Insight System)",
    description:
      "Unlock the full potential of your resume with IRIS, an advanced AI-powered system that provides deep insights into your professional profile. Get personalized feedback, identify skill gaps, receive optimization recommendations, and understand how your resume performs across different industries and roles.",
    category: "Resume ATS Analyzer",
    image: IRIS,
  },
  {
    id: 7,
    to: "QR-Code",
    title: "OR Code Generator",
    description:
      "Create custom QR codes instantly for URLs, text, contact information, Wi-Fi credentials, and more. Our QR Code Generator offers multiple design options, error correction levels, and downloadable formats to help you share information quickly and efficiently across digital and print media.",
    category: "Other",
    image: QRCode,
  },
  {
    id: 8,
    to: "/video-streaming-platform",
    title: "Video Streaming Platform",
    description:
      "Experience the future of video streaming with our advanced platform. Stream your favorite content in HD and 4K quality, watch live events, download for offline viewing, and discover new content with AI-powered recommendations.",
    category: "Other",
    image: VideoStreamPlatform,
    credentials: APP_CREDENTIALS.videoStreaming
  },
  {
    id: 9,
    to: "/urban-farming",
    title: "Urban Farming App",
    description:
      "Transform your urban space into a thriving garden with our comprehensive urban farming solution. Track plant growth, receive personalized care reminders, access expert gardening tips, monitor soil conditions, and connect with a community of urban farmers to maximize your harvest in limited spaces.",
    category: "Other",
    image: UrbanFarming,
    credentials: APP_CREDENTIALS.urbanFarming
  },
  {
    id: 10,
    to: "/expense-tracker",
    title: "Expense Tracker App",
    description:
      "Everything you need to manage your finances. Advanced analytics, smart receipt scanning, budget planning, multi-account support, AI-powered email reports, and comprehensive visualizations to help you take control of your financial future.",
    category: "Other",
    image: ExpenseTracker,
    credentials: APP_CREDENTIALS.expenseTracker
  },
  {
    id: 11,
    to: "/quizorra",
    title: "Online AI Quiz App",
    description:
      "Transform learning with AI-powered quizzes. Create dynamic quizzes instantly using advanced AI technology, host live quiz sessions with real-time participant interaction, track performance on competitive leaderboards, and get instant feedback with detailed analytics to enhance your learning experience.",
    category: "Other",
    image: Quizorra,
    credentials: APP_CREDENTIALS.quizorra
  },
  {
    id: 12,
    to: "360-view-admin-panel",
    title: "360 View Admin Panel",
    description:
      "Experience the full power of 360-degree visualization with our interactive Admin Panel. From immersive 360-degree product views to comprehensive panoramic walkthroughs, our platform brings every angle to life. Explore every detail, interact with 360° scenes, and manage your immersive content—all in one seamless interface.",
    category: "Other",
    image: ThreeD,
    credentials: APP_CREDENTIALS.threeDView
  },
  {
    id: 13,
    to: "/ulcer-sight",
    title: "Ulcer Sight",
    description:
      "Advanced AI-powered Ulcer Sight application.",
    category: "Other",
    image: UlcerSight,
    credentials: APP_CREDENTIALS.ulcerSight
  },
  {
    id: 14,
    to: "/ai-sales-training",
    title: "AI Sales Training",
    description:
      "Empower your showroom sales team with our interactive AI Sales Training app. Salespersons can select an AI customer persona that mimics real-world scenarios, engage in a dynamic Q&A session, and receive a detailed performance score and constructive feedback.",
    category: "Sales Support",
    image: AISalesTraining
  },
  {
    id: 15,
    to: "/walkthrough-training-system",
    title: "Walkthrough Training System",
    description: "Transforming dense machinery manuals and safety SOPs into photorealistic, multilingual AI video walkthroughs and interactive assessments in under 5 minutes.",
    category: "Other",
    image: AIMachineTraining
  },
  {
    id: 16,
    to: "Project-Management-System",
    title: "Project Management System",
    description: "A comprehensive project management system designed to streamline workflows, enhance team collaboration, and track project progress effectively.",
    category: "Other",
    image: PMS,
    credentials: APP_CREDENTIALS.projectManagement
  },
  {
    id: 17,
    to: "/real-estate-platform",
    title: "Real Estate Operations Platform",
    description: "Real estate operations platform for brokers, builders, and internal teams to manage inventory, bookings, payments, and master data.",
    category: "Other",
    image: PropertyImage,
    credentials: APP_CREDENTIALS.realEstatePlatform
  }
];

export default function Projects() {
  const history = useHistory();
  const [activeCategory, setActiveCategory] = useState("All");
  const [filteredCards, setFilteredCards] = useState(cardData);

  // const categories = () => {
  //   const categories = Array.from(
  //     new Set(cardData.map((card) => card.category))
  //   );
  //   return ["All", ...categories.sort()];
  // };

  useEffect(() => {
    if (activeCategory === "All") {
      setFilteredCards(cardData);
    } else {
      setFilteredCards(
        cardData.filter((card) => card.category === activeCategory)
      );
    }
  }, [activeCategory]);

  const categories = [
    "All",
    "Booking Agent",
    "Personal AI Assistant",
    "Resume ATS Analyzer",
    "Sales Support",
    "Smart Planner",
    "Other",
  ];

  const handleTryDemo = (to) => {
    if (to === "QR-Code") {
      window.open(
        "https://demo.conversantech.com/ai-demo/qr-code-generator/",
        "_blank"
      );
    }
    else if(to == "Video-Streaming-Platform"){
      window.open(
        "http://localhost:3000/",
        "_blank"
      );
    }
    else if(to == "360-view-admin-panel"){
      window.open(
        "https://demo.conversantech.com/360-view-admin-panel",
        "_blank"
      );
    }
    else if(to === "Project-Management-System"){
      window.open(
        "https://demo.conversantech.com/project-management-system",
        "_blank"
      );
    }
    else if(to === "/real-estate-platform"){
      window.open(
        "https://demo.conversantech.com/br-demo",
        "_blank"
      );
    }
    // else if(to === "Expense-Tracker"){
    //   window.open(
    //     "https://demo.conversantech.com/expense-tracker",
    //     "_blank"
    //   );
    // }
    // else if(to === "Video-Streaming-Platform"){
    //   window.open(
    //     "https://demo.conversantech.com/video-streaming-platform",
    //     "_blank"
    //   );
    // }
    else {
      history.push(`/ai-demo${to}`);
    }
  };

  return (
    <Wrapper id="projects">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">
              AI/ML Demos – Explore the Possibilities!
            </h1>
            <p className="font13">
              Step into the world of artificial intelligence and machine
              learning with our interactive demos. Witness cutting-edge
              algorithms in action as they analyze data, make intelligent
              predictions, classify objects, and even create innovative content.
              From speech recognition to image analysis, our demos highlight the
              transformative power of AI technologies in reshaping industries
              and enhancing everyday experiences. Start your journey into AI
              innovation today!
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              {/* <ButtonGroup>
                {filters.map((filter) => (
                  <FilterButton
                    key={filter}
                    active={activeFilter === filter}
                    onClick={() => setActiveFilter(filter)}
                  >
                    {filter}
                  </FilterButton>
                ))}
              </ButtonGroup> */}
              <FilterGroup
                categories={categories}
                activeCategory={activeCategory}
                onCategoryChange={setActiveCategory}
              />
            </div>
            {filteredCards.map((card) => (
              <div key={card.id} className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ display: 'flex', padding: '15px', marginBottom: '30px' }}>
                {/* <ProjectBox
                img={ProjectImg1}
                title="Awesome Project"
                text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                action={() => alert("clicked")}
              /> */}
                <ProjectBox
                  img={card.image}
                  title={card.title}
                  text={card.description}
                  to={card.to}
                  action={handleTryDemo}
                  credentials={card.credentials}
                />
              </div>
            ))}
            {/* <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg2}
                title="Awesome Project"
                text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg3}
                title="Awesome Project"
                text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                action={() => alert("clicked")}
              />
            </div> */}
          </div>
          {/* <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg4}
                title="Awesome Project"
                text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg5}
                title="Awesome Project"
                text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg6}
                title="Awesome Project"
                text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                action={() => alert("clicked")}
              />
            </div>
          </div> */}
        </div>
      </div>
      {/* <div className="lightBg">
        <div className="container">
          <Advertising className="flexSpaceCenter">
            <AddLeft>
              <AddLeftInner>
                <ImgWrapper className="flexCenter">
                  <img className="radius8" src={AddImage2} alt="add" />
                </ImgWrapper>
              </AddLeftInner>
            </AddLeft>
            <AddRight>
              <h4 className="font15 semiBold">A few words about company</h4>
              <h2 className="font40 extraBold">A Study of Creativity</h2>
              <p className="font12">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum.
              </p>
              <ButtonsRow
                className="flexNullCenter"
                style={{ margin: "30px 0" }}
              >
                <div style={{ width: "190px" }}>
                  <FullButton
                    title="Get Started"
                    action={() => alert("clicked")}
                  />
                </div>
                <div style={{ width: "190px", marginLeft: "15px" }}>
                  <FullButton
                    title="Contact Us"
                    action={() => alert("clicked")}
                    border
                  />
                </div>
              </ButtonsRow>
            </AddRight>
          </Advertising>
        </div>
      </div> */}
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  padding: 100px 0;
  margin: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 60px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative;
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 15%;
  img {
    width: 100%;
    height: auto;
  }
  @media (max-width: 400px) {
    padding: 0;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin: 20px 0;
`;

const FilterButton = styled.button`
  background-color: ${(props) => (props.active ? "#7620FF" : "#F5F5F5")};
  color: ${(props) => (props.active ? "#fff" : "#000")};
  border: none;
  padding: 10px 15px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #7620ff;
    color: #fff;
    transition: all 0.3s ease-in-out;
  }
`;
